<template>
    <div class="BizXfLoupanItem"
       :class="{'ui-border_bottom':hasBorderBottom}"

       @click.prevent="loupanItemClick(item, index, fromSoj)"
    >
    <a :href="item.url" hidden></a>
        <div class="loupanImg">
            <img class="loupanImg-img" :src="item.default_image"/>
            <i class="loupanImg-icon_center icon-ea82"
               v-if="item.has_video"
            /><!-- 视频 -->
            <div class="loupanImg-iconWrap">
                <i class="icon_wechat"
                   v-if="isFromAjkApp && item.have_wechat"
                /><!-- 微聊 -->
                <i class="icon_quanjing"
                   v-if="item.have_quanjing"
                /><!-- 全景 -->
                <i class="icon_aerial"
                   v-if="item.have_aerial_photo"
                /><!-- 航拍 -->
            </div>
        </div>
        <dl class="loupanDetail">
            <dt class="loupanDetail-nameWrap ellipsis">
                <span class="ellipsis loupanDetail-name">{{ item.loupan_name }}</span>
            </dt>
            <dd class="loupanDetail-region">
                <label class="ellipsis region">
                    {{ item.region_title ? item.region_title : '' }}
                    {{ item.subregion_title ? item.subregion_title : '&nbsp;' }}
                </label>
                <template v-if="item.huxing_area">
                    <span class="dividing-line"/>
                    <div class="ellipsis">{{ item.huxing_area }}</div>
                </template>
            </dd>
            <dd class="loupanDetail-price">
                <template v-if="!!item['new_price']">
                    <template v-if="!!item['new_price']['show_price']">
                        <label class="price">
                            <strong>{{ item['new_price']['show_price'] }}</strong>{{ item['new_price']['unit'] }}
                        </label>
                    </template>
                    <template v-else>
                        <span class="wait-price">{{ item['new_price']['price_pending_desc'] || '售价待定' }}</span>
                        <!-- 推荐价格，比如周边，往期，指导价等 https://igit.58corp.com/_xinfang/user_product/-/blob/master/wenjuan/%E6%9C%AC%E5%9C%B0%E5%8C%96%E4%BF%A1%E6%81%AF/%E4%BB%B7%E6%A0%BC/%E6%A5%BC%E7%9B%98%E6%8E%A8%E8%8D%90%E4%BB%B7%E6%A0%BC%E4%BC%98%E5%8C%96/%E6%A5%BC%E7%9B%98%E6%8E%A8%E8%8D%90%E4%BB%B7%E6%A0%BC%E4%BC%98%E5%8C%96.md -->
                        <span v-if="!!item.reference_price && item['reference_price']['value']"
                              class="nearbyPrice">
                              {{item['reference_price']['prefix']}}<em class="price">{{ item['reference_price']['value']}}</em>{{ item['reference_price']['suffix'] }}
                        </span>
                    </template>
                </template>
                <template v-else-if="!!item['unit_price']">
                    <strong>{{ item['unit_price'] }}</strong>元/m²
                </template>
                <template v-else>
                    <span class="wait-price">售价待定</span>
                    <span v-if="!!item.reference_price && item['reference_price']['value']"
                          class="nearbyPrice">
                          {{item['reference_price']['prefix']}}<em class="price">{{ item['reference_price']['value']}}</em>{{ item['reference_price']['suffix']}}
                    </span>
                </template>
            </dd>
            <dd class="loupanDetail-tags"
                v-if="!!get_tags_html(item)">
                <div v-html="get_tags_html(item)"/>
            </dd>
            <dd class="loupanDetail-adv"
                :class="{'open-act': openAct}"
                v-if="item.yufujin ||
                (item['has_hui'] && item['hui_desc']) ||
                (item['has_qiang'] && item['qiang_desc']) ||
                item['haszhuanche'] ||
                item['haskft'] ||
                item['has_ranklist']">
                <p class="ellipsis flex-center"
                   v-if="item.has_ranklist"
                >
                  <template v-if="item.rank_icon">
                    <img class="rank-flag-img"
                        alt="rank"
                        :src="item.rank_icon"/>
                  </template>
                  <span class="adv-ctx rank-flag-text">{{ item.rank_desc }}</span>
                </p>
                <p class="ellipsis"
                   v-if="item.qiang_desc"
                >
                    <i class="qiang qiang_bg"/>
                    <span class="adv-ctx">{{ item.qiang_desc }}</span>
                </p>
                <p class="ellipsis"
                   v-if="item.hui_desc"
                >
                    <i class="hui hui_bg"></i>
                    <span class="adv-ctx">{{ item.hui_desc }}</span>
                </p>
                <p class="ellipsis"
                   v-if="item.yufujin_desc">
                    <i class="ding ding_bg"></i>
                    <span class="adv-ctx">{{ item.yufujin_desc }}</span>
                </p>
                <p class="ellipsis"
                   v-if="item.kft_desc"
                >
                    <i class="kft kft_bg"></i>
                    <span class="adv-ctx">{{ item.kft_desc }}</span>
                </p>
                <span class="adv-toggle"
                      v-if="(+ item.has_ranklist+ item.haskft + item.has_hui + item.has_qiang + item.yufujin) > 1"
                      @click.prevent.stop="getMoreLpActivity()">
                    <em :class="{'icon-ebe4': !openAct, 'icon-ebe3': !!openAct }"/>
                </span>
            </dd>
        </dl>
    </div>
</template>
<script>
import { concatSoj } from '../../utils/common/base';

export default {
  name: 'BizXfLoupanItem',
  props: {
    item: { // 楼盘item详细信息
      type: Object,
      default: () => {
      },
    },
    index: { // 第几个元素
      type: Number,
      default: 0,
    },
    fromSoj: {// from码
      type: String,
      default: '',
    },
    isFromAjkApp: {// 是否来自安居客app
      type: Boolean,
      default: false,
    },
    hasBorderBottom: {// 是否显示底部border
      type: Boolean,
      default: true,
    },
    loupanItemClick: {// 整体点击跳转
      type: Function,
      default: (item, index, fromSoj) => {
        window.location.href = concatSoj(item.url, fromSoj);
      },
    },
  },

  data() {
    return {
      openAct: false,
    };
  },
  computed: {},
  methods: {
    /**
     * 活动展开或关闭
     */
    getMoreLpActivity() {
      this.openAct = !this.openAct;
    },
    /**
     * 组装活动html
     * @param loupan_info
     * @returns {string}
     */
    get_tags_html(loupanInfo) {
      const rs = [];
      if (loupanInfo.display_price_type_str) {
        const arr = [];
        arr.classname = 'saleHouseTag ui-tag_blue';
        arr.name = loupanInfo.display_price_type_str;
        rs.push(arr);
      }

      if (loupanInfo.new_status_sale) {
        const arr = [];
        if (loupanInfo.new_status_sale === '在售' || loupanInfo.new_status_sale === '招租中') {
          arr.classname = 'saleHouseTag on-sale';
          arr.name = loupanInfo.new_status_sale;
        } else if (loupanInfo.new_status_sale === '待售' || loupanInfo.new_status_sale === '待租') {
          arr.classname = 'saleHouseTag wait-sale';
          arr.name = loupanInfo.new_status_sale;
        } else if (loupanInfo.new_status_sale === '售罄' || loupanInfo.new_status_sale === '满租') {
          arr.classname = 'saleHouseTag ui-tag_grey';
          arr.name = loupanInfo.new_status_sale;
        }
        rs.push(arr);
      }

      if (loupanInfo.loupan_tags) {
        const tags = loupanInfo.loupan_tags.slice(0, 2);
        tags.forEach((item) => {
          const arr = [];
          arr.classname = 'defaultTag ui-tag_grey';
          arr.name = item;
          rs.push(arr);
        });
      }
      let html = '';
      rs.forEach((item) => {
        html += `<em class="${item.classname}">${item.name}</em>`;
      });
      return html;
    },
  },
};
</script>
<style src="../../assets/iconfonts.css" scoped></style>
<style src="../../assets/commonResource.css" scoped></style>
<style scoped>
    .BizXfLoupanItem {
        display: -webkit-box;
        -webkit-box-flex: 1;
        padding: 18px 15px 18px 0;
        margin-left: 15px;
        background-color: #fff;
        color: #666;
        z-index: 1;
        position: relative;
        overflow: hidden;
        line-height: initial;
        text-decoration: none;
        outline: 0;
        -webkit-tap-highlight-color: transparent;
        tap-highlight-color: transparent;
        font-family: arial;
        -webkit-font-smoothing: antialiased;
    }
    .ui-border_bottom:after {
        content: " ";
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        pointer-events: none;
        border-bottom: 1px solid #e6e6e6;
    }
    @media screen and (-webkit-min-device-pixel-ratio: 2) {
        .ui-border_bottom:after {
            width:200%;
            height: 200%;
            -webkit-transform: scale(.5);
            transform: scale(.5);
            -webkit-transform-origin: left top;
            transform-origin: left top
        }
    }

    @media screen and (-webkit-min-device-pixel-ratio: 3) {
        .ui-border_bottom:after {
            width:300%;
            height: 300%;
            -webkit-transform: scale(.333);
            transform: scale(.333);
            -webkit-transform-origin: left top;
            transform-origin: left top
        }
    }

    .BizXfLoupanItem .ellipsis {
        overflow-x: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .BizXfLoupanItem .flex-center {
      display: flex;
      align-items: center;
    }

    .BizXfLoupanItem p {
        margin: 0;
    }
    .BizXfLoupanItem em, .BizXfLoupanItem i {
        font-style: normal;
    }
    /*楼盘默认图片&icon start*/
    @media screen and (max-width: 400px) {
        .BizXfLoupanItem .loupanImg {
            position: relative;
            height: 90px;
            width: 100px;
        }

        .BizXfLoupanItem .loupanImg-icon_center {
            position: absolute;
            left: 35px;
            bottom: 28px;
        }
    }

    @media screen and (min-width: 400px) {
        .BizXfLoupanItem .loupanImg {
            position: relative;
            height: 90px;
            width: 120px;
        }

        .BizXfLoupanItem .loupanImg-icon_center {
            position: absolute;
            left: 45px;
            bottom: 28px;
        }
    }

    .BizXfLoupanItem .loupanImg-img {
        height: 100%;
        width: 100%;
    }

    .BizXfLoupanItem .loupanImg-icon_center{
        color: #fff;
        font-size: 30px;
        width: 30px;
        height: 30px;
        border-radius: 100%;
        background: rgba(0, 0, 0, 0.5);
    }

    .BizXfLoupanItem .loupanImg-iconWrap {
        position: absolute;
        vertical-align: middle;
        text-align: center;
        overflow-y: hidden;
        bottom: 2px;
        left: 3px;
        height: 18px;
        font-size: 18px;
        width: auto;
    }

    .BizXfLoupanItem .loupanImg-iconWrap i {
        display: inline-block;
        width: 36px;
        height: 36px;
        transform-origin: left top;
        transform: scale(0.5);
    }

    .BizXfLoupanItem .loupanImg-iconWrap i:not(:first-child) {
        position: relative;
        margin-left: -14px;
    }

    /*楼盘默认图片&icon end*/

    /*楼盘详细信息 start*/
    .BizXfLoupanItem .loupanDetail {
        margin-left: 10px;
        margin-top: 0;
        margin-bottom: 0;
        -webkit-box-flex: 1;
        overflow:hidden;
    }

    .BizXfLoupanItem .loupanDetail-nameWrap{
        display: flex;
        font-size: 17px;
        line-height: 17px;
        display: inline-block;
        vertical-align: middle;
        margin-bottom: 2px;
        padding-top: 2px;
        max-width: 100%;
    }

    .BizXfLoupanItem .loupanDetail-name {
        color: #1f2326;
        font-weight: bold;
        flex: 1
    }

    .BizXfLoupanItem .loupanDetail-serviceTag {
        display: block;
        border: 1px solid #f0e1d6;
        font-size: 12px;
        line-height: 12px;
        padding: 2px 6px 1px;
        margin-left: 6px;
        color: #d3a585;
    }

    .BizXfLoupanItem .loupanDetail-region,
    .BizXfLoupanItem .loupanDetail-price,
    .BizXfLoupanItem .loupanDetail-tags,
    .BizXfLoupanItem .loupanDetail-adv {
        display: -webkit-box;
        margin-top: 4px;
        font-size: 13px;
        height:19px;
        overflow: hidden;
        padding-left: 0;
        margin-left: 0;
    }

    .BizXfLoupanItem .loupanDetail-region {
        margin-top: 4px;
    }

    .BizXfLoupanItem .loupanDetail-region .regin{
        display: inline-block;
        color: #676c73;
        font-size: 13px;
    }

    .BizXfLoupanItem .dividing-line {
        height: 8px;
        width: 1px;
        position: relative;
        display: block;
        margin-right: 6px;
        bottom: -5px;
        border-left: 1px solid #e6e6e6;
    }

    .BizXfLoupanItem dd label:first-child {
        display: inline-block;
        margin-right: 6px;
        -webkit-box-flex: 1;
    }
    /*价格 start*/
    .BizXfLoupanItem .loupanDetail-price {
        margin-top: 5px;
        color: #969696;
        font-size: 13px;
        overflow: hidden;
        display: -webkit-box;
    }

    .BizXfLoupanItem .loupanDetail-price strong {
        font-size: 17px;
        font-weight: bold;
        line-height: 15px;
    }

    .BizXfLoupanItem .loupanDetail-price .price {
        color: #fa4600;
        font-size: 13px;
        font-weight: bold;
        text-align: right;
    }

    .BizXfLoupanItem .nearbyPrice {
        text-align: right;
        margin-left: 6px;
        -webkit-box-flex: 2;
        color: #676c73;
        font-weight: normal;
    }

    .BizXfLoupanItem .wait-price {
        color: #676c73;
        font-weight: normal;
    }
    /*价格 end*/
    /*展开收起 start*/
    .BizXfLoupanItem .loupanDetail-adv {
        position: relative;
        display: block;
        height: 27px;
        margin-top: 0;
    }

    .BizXfLoupanItem .open-act {
        height: auto;
    }

    .BizXfLoupanItem .loupanDetail-adv p {
        width: 80%;
        margin-top: 4px;
        font-size: 13px;
    }

    .BizXfLoupanItem .loupanDetail-adv p:first-child {
        margin-top: 8px;
    }

    .BizXfLoupanItem .loupanDetail-adv i {
        display: inline-block;
        margin-right: 5px;
        color: #fff;
        width: 15px;
        height: 15px;
        vertical-align: middle;
    }

    .BizXfLoupanItem .qiang {
        display: inline-block;
        vertical-align: middle;
        width: 15px;
        height: 15px;
        background-size: 15px 15px;
    }

    .BizXfLoupanItem .hui {
        display: inline-block;
        vertical-align: middle;
        width: 15px;
        height: 15px;
    }

    .BizXfLoupanItem .ding {
        display: inline-block;
        vertical-align: middle;
        width: 15px;
        height: 15px;
    }

    .BizXfLoupanItem .kft {
        display: inline-block;
        vertical-align: middle;
        width: 15px;
        height: 15px;
    }


    .BizXfLoupanItem .loupanDetail-adv .adv-toggle {
        position: absolute;
        top: 0;
        padding-top: 7px;
        right: 0;
        width: 40px;
        height: 26px;
        text-align: center;
        text-align: -webkit-center;
        margin-right: -13px;
    }

    .BizXfLoupanItem .loupanDetail-adv .adv-toggle em {
        color: #999;
        margin: 3px 0 0;
        background-image: none;
        transform: scale(0.333);
        height: 15px;
        width: 9px;
        display: block;
    }

    .BizXfLoupanItem .adv-ctx {
        position: relative;
        vertical-align: middle;
        display: inline-block;
        bottom: 0;
    }
    /*展开收起 end*/
    /*楼盘详细信息 end*/
</style>
<style>
    /*标签 start*/
    .BizXfLoupanItem .loupanDetail .loupanDetail-tags {
        margin-top: 3px;
        height: 20px;
        font-size: 0;
    }

    .BizXfLoupanItem .loupanDetail-tags em {
        display: inline-block;
        font-size: 12px;
        height: 18px;
        line-height: 18px;
        padding: 0 6px;
        margin-right: 5px;
        font-style: normal
    }

    .BizXfLoupanItem .saleHouseTag,
    .BizXfLoupanItem .defaultTag {
        height: 17px;
        line-height: 17px;
        border: none;
    }

    .BizXfLoupanItem .ui-tag_blue {
        background: #f3f8fa;
        color: #7caee8;
    }

    .BizXfLoupanItem .ui-tag_green {
        background: #f3faf3;
        color: #6fc27f;
    }

    .BizXfLoupanItem .ui-tag_grey {
        background: #f9f9f9;
        color: #a3a8ad;
    }
    .BizXfLoupanItem .ui-tag_orange {
        background: #fff5f1;
        color: #f69470;
    }
    /*标签 end*/
    .BizXfLoupanItem dd.loupanDetail-adv .rank-flag-img {
        width: auto;
        height: 13px;
        display: inline-block;
    }
    .BizXfLoupanItem dd.loupanDetail-adv .rank-flag-text {
      vertical-align: baseline;
      margin-left: 5px;
      bottom: 0;
    }
</style>
